import { schema } from 'normalizr';

export const placeMetaTypeSchema = new schema.Entity('placeMetaTypes');
export const placeMetaTypesSchema = new schema.Array(placeMetaTypeSchema);
